import { CustomHttpClient, IRequestOptions } from './../../providers/CustomHttpClient';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { RessarcimentoParam } from '../../model/ressarcimentoparam';
import { environment } from '../../../environments/environment.prod'


@Injectable({
  providedIn: 'root'
})
export class RessarcimentoParamService {

  constructor(private http: CustomHttpClient) { }

  OnSearchRessarcimentoParam(idRessarcimento: number) {
    return this.http.Get("api/ressarcimentoparam/GetRessarcimentoParam/" + idRessarcimento);
  }

  OnSearchProduto(idRessarcimento: number, filtro: string) {  
    return this.http.Get("api/ressarcimentoparam/GetProdutos/" + idRessarcimento+"?filter="+filtro);
  }

  OnZipCode(cep: number){
    return this.http.Get(environment.urlCommom+"api/v1/Address/"+cep);
  }

}
